export default {
  dialogTitle: "Edit Case",
  caseName: {
    label: "Case Name",
    placeholder: "Please enter case name (required)",
  },
  caseType: {
    label: "Case Type",
    placeholder: "Please select case type",
  },
  caseDescription: {
    label: "Case Description",
    placeholder: "Please enter case description",
  },
  buttons: {
    reset: "Reset",
    confirm: "Confirm",
  },
  messages: {
    editSuccess: "Edit successful",
  },
  validation: {
    caseNameRequired: "Case name is required",
    caseNameLength: "Length must be between 1 and 20 characters",
    caseTypeRequired: "Please select case type",
    caseDescriptionLength: "Length must be between 1 and 200 characters",
  },
};
